import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=6cfaa91f&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cfaa91f')) {
      api.createRecord('6cfaa91f', component.options)
    } else {
      api.reload('6cfaa91f', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=6cfaa91f&", function () {
      api.rerender('6cfaa91f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2n937v0qYSzQl/JS/comp/ErrorMessage.vue"
export default component.exports